/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import 'roboto-fontface/css/roboto/roboto-fontface.css'; // Roboto fonts
import '@fortawesome/fontawesome-free/css/all.css'; // fa
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // md

import uk from 'vuetify/src/locale/uk.ts';
import ru from 'vuetify/src/locale/ru.ts';
import en from 'vuetify/src/locale/en.ts';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { uk, ru, en },
    current: 'en',
  },
  icons: {
    iconfont: 'md' || 'fa',
  },
});
